@if (iconUrl) {
  <img [src]="iconUrl" [ngClass]="additionalClasses" [attr.width]="width" [attr.height]="height"
    (contextmenu)="preventDefault($event)" />
}